module.exports = __webpack_public_path__ + "static/media/ios-medical.7d048935.svg";